module.exports = __webpack_public_path__ + "static/media/luna_plus.b3c93db1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/luna_plus.jpeg
// module id = 285
// module chunks = 0